import React from 'react';
import { Helmet } from 'react-helmet-async';
import { veganMovement } from '../mock';

const MovementPage = () => {
  return (
    <>
      <Helmet>
        <title>Championing Veganism in Bangalore | Naru Tofu</title>
        <meta name="description" content="Join Naru Tofu's movement - school partnerships, hospital programs, educational initiatives, and Bangalore's first Japanese cloud kitchen." />
        <link rel="canonical" href="https://narutofu.com/movement" />
      </Helmet>
      <section id="vegan" className="vegan-section section-padding" style={{ minHeight: '100vh' }}>
      <div className="container">
        <h1 className="hero-large" style={{ textAlign: 'center', marginBottom: '24px' }}>
          {veganMovement.title}
        </h1>
        <p className="body-large" style={{ textAlign: 'center', marginBottom: '60px', maxWidth: '800px', margin: '0 auto 60px' }}>
          {veganMovement.mission}
        </p>
        
        <div className="initiatives-grid">
          {veganMovement.initiatives.map((initiative, index) => (
            <div key={initiative.title} className="initiative-card">
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>{initiative.title}</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>{initiative.description}</p>
            </div>
          ))}
        </div>
        
        {veganMovement.impact.length > 0 && (
          <div className="impact-stats">
            {veganMovement.impact.map((stat, index) => (
              <div key={stat.label} className="impact-item">
                <span className="impact-number">{stat.number}</span>
                <span className="body-small" style={{ color: 'var(--text-secondary)' }}>{stat.label}</span>
              </div>
            ))}
          </div>
        )}
        
        <div style={{ marginTop: '80px', textAlign: 'center' }}>
          <h2 className="heading-1" style={{ marginBottom: '24px' }}>Join the Movement</h2>
          <p className="body-large" style={{ maxWidth: '700px', margin: '0 auto 32px' }}>
            Together, we're building a sustainable, compassionate food system in Bangalore. Every block of tofu you choose makes a difference.
          </p>
          <a href="/contact" className="btn-primary">Get Involved</a>
        </div>
      </div>
    </section>
    </>
  );
};

export default MovementPage;
